/* squiq-attribution.js
   SQUIQ — aus layout/theme.liquid herausgeloest (D1-Migration Be Yours 9.5.1, TSK-1740).
   Zweck: First-Touch-Werbekanal je Session in sessionStorage und von dort in jedes
          Formularfeld mit der Klasse .squiq-attr (contact[Kampagne]).
   Grund der Auslagerung: ein Theme-Update setzt Vanilla-Dateien byte-genau zurueck.
   Code in einer eigenen Datei ueberlebt jedes Update; Code IN einer Theme-Datei nicht.
   Eingebunden in layout/theme.liquid. */
/* squiq Attribution-Capture (Stufe 2, TSK-1176) — Werbekanal-Herkunft ins Lead-Formular.
   LIEGT IM LAYOUT und laeuft damit auf JEDER Shop-Seite (seit 17.08.): der First Touch wird
   dort erfasst, wo der Besucher ankommt — nicht erst auf der Lead-Seite. Vorher sass das
   Script nur auf den zwei Formularseiten und sah die Kampagnen-Parameter nicht mehr, wenn
   jemand ueber Startseite/Produktseite/Blog einstieg und sich durchklickte (belegt am ersten
   echten Fall, 17.08. 12:10: nur `ref=www.squiq.de`, keine Kanal-Aussage).
   Die .squiq-attr-Felder stehen weiterhin in den Formularen — nur die werden abgesendet.
   First-party sessionStorage, kein Cookie, kein Drittanbieter, session-only (DSGVO-schonend).
   Publiziert BEWUSST kein Analytics-Event (Paid-Ads-Doktrin §4b Parameter-Namen-Regel).
   Modell: First Touch je Session — ein spaeterer BEZAHLTER Touch ueberschreibt aber einen
   vorher gespeicherten Satz ohne Kampagnen-Parameter, sonst verliert ein Nutzer, der erst
   organisch kam und dann auf eine Anzeige klickt, seinen Kanal.
   Ausgabe: EIN kompaktes Feld contact[Kampagne], Format "k=v; k=v" — leere Schluessel fallen
   raus, ohne jeden Wert bleibt das Feld leer ("nicht gemessen", NICHT kanal=none).
   DIREKTEINSTIEG WIRD ERFASST (seit 09.09., TSK-1584): Das Write-Gate verlangte frueher einen
   Referrer ODER einen Kampagnen-Parameter. Wer ohne beides ankam (getippt, Lesezeichen, QR,
   Mail-Client, referrer-strippender In-App-Browser) hinterliess GAR NICHTS — auch kein lp,
   obwohl location.pathname immer bekannt ist. Jetzt wird auf der ERSTEN Seite jeder Session
   immer geschrieben; der Fall "kein externer Referrer und kein Parameter" traegt entry=direct
   und ist damit eine MESSUNG, unterscheidbar vom verlorenen First Touch (nur ref=www.squiq.de
   -> C1 Regel 0).
   WIEDERHERSTELLUNG NACH SPEICHERVERLUST (seit 01.11.2026, TSK-555): sessionStorage haengt am
   einzelnen Tab. Neuer Tab, In-App-Browser oder verworfener Tab starten mit leerem Speicher,
   der Referrer ist dann die eigene Domain, und die Herkunft war weg — 16 von 21 ungestempelten
   Formular-Leads 22.09.–31.10. trugen nur `ref=www.squiq.de`. Deshalb liegt eine KOPIE des
   Session-Satzes zusaetzlich in localStorage (30 Tage), und NUR wenn der Referrer die eigene
   Domain ist und kein Parameter vorliegt, wird daraus wiederhergestellt. Ein neuer externer
   Einstieg oder ein Direkteinstieg bleibt eine neue Session wie bisher — das Modell
   "First Touch je Session" aendert sich nicht.
   CONSENT-SPERRE: localStorage wird nur gelesen und geschrieben, wenn
   Shopify.customerPrivacy.analyticsProcessingAllowed() true liefert (consentmanager →
   Shopify-Integration, Kategorie analytics). Liefert es false, wird die Kopie geloescht. Ist
   die API beim Laden noch nicht bereit, laeuft der Abgleich nach dem Consent-Ereignis bzw.
   nach window.load nochmals. Ohne Einwilligung verhaelt sich das Script wie vor dem 01.11.
   Ausgabeformat unveraendert (gleiche Schluessel, gleiche Reihenfolge) — C1 bleibt gueltig.
   Gelesen von scheduled-task-skill-v5.md Schritt C1.
   Doku: 03-3_Lead_Anleitung §2 (attribution{}) + Paid-Ads-Doktrin §8a. */
(function(){
  try{
    var KS='squiq_attribution', KL='squiq_attribution_kopie', TTL=30*864e5;
    var P=new URLSearchParams(location.search);
    var KEYS=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'];
    var clean=function(v){ return String(v||'').replace(/[;\r\n]+/g,' ').trim(); };
    var host=function(h){ return String(h||'').toLowerCase().replace(/^www\./,''); };
    var consent=function(){ /* true = erlaubt, false = abgelehnt, null = API noch nicht bereit */
      try{ var cp=window.Shopify && window.Shopify.customerPrivacy;
        if(!cp || typeof cp.analyticsProcessingAllowed!=='function') return null;
        return !!cp.analyticsProcessingAllowed(); }catch(e){ return null; } };
    var hasParam=KEYS.some(function(k){ return P.get(k); });
    var ref=clean((document.referrer||'').replace(/^https?:\/\//,'').split('/')[0]).slice(0,120);
    var intern=!!ref && host(ref)===host(location.hostname);
    var st=null; try{ st=JSON.parse(sessionStorage.getItem(KS)||'null'); }catch(e){}
    var neu=false;
    var stPaid=!!(st && KEYS.some(function(k){ return st[k]; }));
    if(!st || (hasParam && !stPaid)){
      /* referrer nur als Host, landing_page nur als Pfad — die Query dupliziert die utm-Werte
         und blaeht die Mail-Zeile unnoetig auf. */
      st={referrer:ref,
          landing_page:clean(location.pathname).slice(0,120),
          entry:(!ref && !hasParam) ? 'direct' : ''};
      KEYS.forEach(function(k){ st[k]=clean(P.get(k)).slice(0,200); });
      neu=true;
      try{ sessionStorage.setItem(KS, JSON.stringify(st)); }catch(e){}
    }
    var fill=function(){
      if(!st) return;
      var out=[];
      KEYS.forEach(function(k){ if(st[k]) out.push(k+'='+st[k]); });
      if(st.referrer) out.push('ref='+st.referrer);
      if(st.entry) out.push('entry='+st.entry);
      if(st.landing_page) out.push('lp='+st.landing_page);
      var val=out.join('; ');
      document.querySelectorAll('.squiq-attr').forEach(function(el){ el.value=val; });
    };
    var abgleich=function(){
      var c=consent();
      if(c===null) return false;
      try{
        if(!c){ localStorage.removeItem(KL); return true; }
        if(neu && intern && !hasParam){
          var k=JSON.parse(localStorage.getItem(KL)||'null');
          if(k && k.st && (Date.now()-k.ts)<TTL){
            st=k.st; neu=false;
            try{ sessionStorage.setItem(KS, JSON.stringify(st)); }catch(e){}
            fill();
          }
        }
        /* Kopie nur aus einem Satz mit echter Spur — ein verlorener First Touch (nur eigener
           Referrer) darf eine gute Kopie nicht ueberschreiben. */
        var spur=KEYS.some(function(k){ return st[k]; }) || st.entry==='direct' || (st.referrer && host(st.referrer)!==host(location.hostname));
        if(spur) localStorage.setItem(KL, JSON.stringify({ts:Date.now(), st:st}));
      }catch(e){}
      return true;
    };
    fill();
    if(!abgleich()){
      var nochmal=function(){ abgleich(); };
      document.addEventListener('visitorConsentCollected', nochmal);
      window.addEventListener('load', function(){ setTimeout(nochmal, 1500); });
    }
  }catch(e){}
})();
